import { defineComponent, ref } from '@vue/composition-api'
import './SystemUpgrade.scss'
const SystemUpgrade = defineComponent({
  setup(props, context) {
    const num = ref(0)
    const jumpInSystemClick = () => {
      num.value++
      if (num.value === 5) {
        context.emit('changeIsNormal', true)
      }
    }
    return () => (
      <div class="sys-up-container">
        <div class="img-tips"></div>
        <div class="word-tips">
          <p>Dear customers,</p>
          <p>
            The system is being upgraded and is expected to be completed at
            {window.location.pathname.indexOf('/answerSurvey') !== -1
              ? '9:30'
              : '12:30'}
            . Please visit later.
          </p>
          <p>
            We appreciate your support and look forward to providing you with a
            better service experience after the upgrade is completed.
          </p>
          <p onClick={jumpInSystemClick}>Best regards</p>
        </div>
      </div>
    )
  }
})
export default SystemUpgrade
